import { InvalidUrlError } from '../../../common/errors/errors';
import { BaseGQLService } from '../../../common/services/BaseGQLService';
import { ModelType } from '../../../common/utils/GQLIdEncoder';
import { ProjectMapper } from '../mappers/ProjectMapper';
import { Project } from '../models/Project';

const PROJECT_FRAGMENT = `
id
name
lastAnalysis
defaultProfile {
  id
  name
  type
}
vulnerabilities {
  totalCount
}
`;

export const GET_PROJECT_QUERY = `
query($id: ID!) {
  project: node(id: $id) {
    ... on Project {
      ${PROJECT_FRAGMENT}
    }
  }
}`;

export class ProjectRepository extends BaseGQLService {
  private readonly mapper = new ProjectMapper();

  async getProject(id: number): Promise<Project> {
    return this.query(
      GET_PROJECT_QUERY,
      {
        id: this.gqlIdEncoder.encode(ModelType.Project, id),
      },
      (data) => {
        if (!data.project) {
          throw new InvalidUrlError(`Invalid request: could not find Project ${id}`);
        }
        return this.mapper.mapGQLModel(data.project);
      }
    );
  }
}
